import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const PatronsPage = lazyNamed(() => import('./pages'), 'PatronsPage');
const PatronNewPage = lazyNamed(() => import('./pages'), 'PatronNewPage');
const PatronsImportPage = lazyNamed(() => import('./pages'), 'PatronsImportPage');
const PatronCategoriesPage = lazyNamed(() => import('./pages'), 'PatronCategoriesPage');
const PatronAttributesPage = lazyNamed(() => import('./pages'), 'PatronAttributesPage');
const PatronDetailPage = lazyNamed(() => import('./pages'), 'PatronDetailPage');
const PatronListsPage = lazyNamed(() => import('./pages'), 'PatronListsPage');
const StaffAccountsPage = lazyNamed(() => import('./pages'), 'StaffAccountsPage');

/**
 * Staff routes for features/patrons. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const patronsRoutes: RouteObject[] = [
  { path: 'patrons', element: <RequirePermission permission={['borrowers']}><PatronsPage /></RequirePermission> },
  { path: 'patrons/new', element: <RequirePermission permission={['borrowers']}><PatronNewPage /></RequirePermission> },
  { path: 'patrons/import', element: <RequirePermission permission={['import', 'borrowers']}><PatronsImportPage /></RequirePermission> },
  { path: 'patrons/categories', element: <RequirePermission permission={['management']}><PatronCategoriesPage /></RequirePermission> },
  { path: 'patrons/attributes', element: <RequirePermission permission={['management', 'parameters']}><PatronAttributesPage /></RequirePermission> },
  { path: 'patrons/:id', element: <RequirePermission permission={['borrowers']}><PatronDetailPage /></RequirePermission> },
  { path: 'patron-lists', element: <RequirePermission permission={['borrowers']}><PatronListsPage /></RequirePermission> },
  { path: 'staff-accounts', element: <RequirePermission permission={['permissions']}><StaffAccountsPage /></RequirePermission> },
];
